import { useLocation } from 'react-router-dom'
import PageHeader from '../components/PageHeader'
import { pages } from '../data/content'

export default function Legal() {
  const { pathname } = useLocation()
  const page = pages.legal[pathname]

  if (!page) return null

  return (
    <main className="py-[clamp(28px,4.5vw,60px)]">
      <PageHeader title={page.title} />

      {page.bodyHtml ? (
        <div
          data-reveal
          className="article-body legal-body mt-10 max-w-[720px] text-copy"
          dangerouslySetInnerHTML={{ __html: page.bodyHtml }}
        />
      ) : null}
    </main>
  )
}
